import { useEffect, useState } from "react";
import { Check, ChevronsUpDown, Loader2, Search } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const sub = (c) => [c.phone, c.email, c.address].filter(Boolean).join(" · ");

export const CustomerSearchSelect = ({ selected, onSelect, placeholder = "Search customers…", testid = "customer-search", disabled, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    let live = true;
    setLoading(true);
    const t = setTimeout(() => {
      const params = new URLSearchParams({ page: "1", page_size: "20", active_only: "true" });
      if (q.trim()) params.set("q", q.trim());
      api.get(`/customers?${params}`)
        .then(({ data }) => live && setItems(data.items || []))
        .catch(() => live && setItems([]))
        .finally(() => live && setLoading(false));
    }, 250);
    return () => { live = false; clearTimeout(t); };
  }, [q, open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled}
          className={`flex h-9 w-full items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 text-sm shadow-sm disabled:opacity-50 ${className}`}
          data-testid={testid}>
          <span className={`truncate ${selected ? "text-zinc-900" : "text-zinc-500"}`}>{selected ? selected.name : placeholder}</span>
          <ChevronsUpDown className="w-3.5 h-3.5 text-zinc-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[min(420px,90vw)]" align="start">
        <Command shouldFilter={false}>
          <CommandInput value={q} onValueChange={setQ} placeholder="Name, phone, email or address" data-testid={`${testid}-input`} />
          <CommandList>
            {loading && <div className="flex items-center gap-2 px-3 py-2 text-xs text-zinc-500"><Loader2 className="w-3 h-3 animate-spin" />Searching…</div>}
            {!loading && <CommandEmpty><span className="inline-flex items-center gap-1 text-xs"><Search className="w-3 h-3" />No customers match</span></CommandEmpty>}
            <CommandGroup heading={q.trim() ? "Matches" : "Recent customers"}>
              {items.map((c) => (
                <CommandItem key={c.id} value={c.id} onSelect={() => { onSelect(c); setOpen(false); setQ(""); }} data-testid={`${testid}-option-${c.id}`}>
                  <Check className={`w-3.5 h-3.5 mr-2 shrink-0 ${selected?.id === c.id ? "opacity-100 text-[#FF5A00]" : "opacity-0"}`} />
                  <div className="min-w-0">
                    <div className="text-sm truncate">{c.name}</div>
                    {sub(c) && <div className="text-[11px] text-zinc-500 truncate">{sub(c)}</div>}
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
